import { defineCustomElement } from 'vue';
import Gallery from './Gallery.ce.vue';

const gscGallery = defineCustomElement(Gallery);

customElements.define('gsc-gallery', gscGallery);